// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"3084":"cd97724e","9092":"47b08ab5"}[chunkId] || chunkId) + "." + {"1817":"3582f486a78084c3","3068":"d5b34c89807c7173","3084":"47259c1b975f4d77","4735":"5b878cc65c15621c","8536":"588d0d6ca28486b4","9092":"7956ba086b3efbc4"}[chunkId] + ".js";
};